import React from "react";

const STATS = [
	{num: '20+', label: 'Yıllık deneyim'},
	{num: '14', label: 'Site & apartman'},
	{num: '7/24', label: 'Operasyon desteği'},
	{num: '%98', label: 'Memnuniyet oranı'},
];

const About = () => {
	return (
		<section className='about' id='hakkimizda'>
			<div className='about-inner'>
				<div className='about-heading'>
					<span className='section-eyebrow'>Hakkımızda</span>
					<h1>Yaşam alanlarınız için 360° yönetim.</h1>
					<p>
						Mülk yönetimini standartlara bağlayarak, yöneticiler ve
						sakinler için şeffaf, ölçülebilir ve sürdürülebilir bir
						hizmet anlayışı sunuyoruz.
					</p>
				</div>
				<div className='about-body'>
					<p>
						<strong>Proteam Yönetim</strong> olarak; insanın yaşam
						alanında mutlu olmasını temel görev kabul ediyor, mülkiyet
						ve insan ilişkilerinde doğal ya da suni nedenlerden
						kaynaklanan sorunlara çözümler üretiyoruz.
					</p>
					<p>
						Site, blok ve apartman yönetiminde Türkiye'deki kalite
						çıtasını yükseltmek üzere uzman kadromuz ve çözüm
						ortaklarımızla yüksek standartlı projeler ve hizmetler
						sunuyoruz.
					</p>
					<div className='stats-row'>
						{STATS.map((s) => (
							<div className='stat-item' key={s.label}>
								<div className='stat-num'>{s.num}</div>
								<div className='stat-label'>{s.label}</div>
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
